import { useEffect, useState } from "react";

const WHISPERS = [
  [3.5, "The void holds midnight"],
  [5, "The void holds the small hours"],
  [7.5, "The void holds dawn"],
  [11, "The void holds morning light"],
  [14, "The void holds noon"],
  [17, "The void holds the long afternoon"],
  [20, "The void holds dusk"],
  [22, "The void holds evening"],
  [24, "The void holds the late hour"],
];

export function localHour() {
  const forced = parseFloat(new URLSearchParams(window.location.search).get("hour"));
  if (Number.isFinite(forced)) return ((forced % 24) + 24) % 24;
  const d = new Date();
  return d.getHours() + d.getMinutes() / 60;
}

export function hourWhisper(hour) {
  return WHISPERS.find(([until]) => hour < until)[1];
}

export function useHourWhisper() {
  const [whisper, setWhisper] = useState(() => hourWhisper(localHour()));
  useEffect(() => {
    const id = setInterval(() => setWhisper(hourWhisper(localHour())), 60_000);
    return () => clearInterval(id);
  }, []);
  return whisper;
}
